import React from 'react'

import ProjectUser from "../../../../../model2/project-user/project-user"
import FieldView from "../../../../../fields3/render/view"

type Props = {
    projectUser     : ProjectUser
}

// const debug = "ModalUser_InheritanceNotification"
const debug = false

export default function ModalUser_InheritanceNotification(props: Props) {

    if (!props.projectUser.inheritance) return null

    const inheritedFromProject = props.projectUser.inheritedFromProject

    const onInheritedAccessClick = () => {
        debug && console.log(debug, 'onInheritedAccessClick')
        if (inheritedFromProject.acl.hasClientAccess) {
            inheritedFromProject.goTo()
        }
    }

    const inheritanceClasses = Classes('m-l-5 m-r-5', {
        'ui5-txt-link': inheritedFromProject.acl.hasClientAccess && !inheritedFromProject.isWorkspace
    })

    return (
        <div className="ui5-notification notification-inline m-b-15">
            <div className="message fl-ac">
                <div className="icon ui5-ico-13 i5-inherited m-r-10"/>
                <div className="text flex-row">
                    This user is inherited from
                    <span className = {inheritanceClasses}
                          onClick   = {onInheritedAccessClick}>
                        <FieldView className    = "m-r-5"
                                   field        = {gd.fields.project.projectIcon}
                                   model        = {inheritedFromProject}/>
                        {inheritedFromProject.name}
                    </span>
                </div>
            </div>
        </div>
    )
}
